import {Component, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-floating-div',
  templateUrl: './floating-div.component.html',
  styleUrls: ['./floating-div.component.css']
})
export class FloatingDivComponent implements OnInit {

  @ViewChild('divComponent', { static: true }) elementRef;

  @Input() loadPercentage = 75;
  @Input() speed:number = 1;
  @Input() loadDelay:number = 0;

  private offsetTop: number;
  private height: number;
  private elementHeight: number;
  private scrollPosition: number;

  private inZone = false;

  opacity = 0;

  element: HTMLElement;

  constructor(

  ) { }

  ngOnInit() {
    window.addEventListener('scroll', this.scrollHandler, true);
    window.addEventListener('load', this.loadHandler, true);
    this.scrollHandler();
  }

  loadHandler = (): void => {
    this.scrollHandler()
  };

  scrollHandler = (): void => {
    this.element = this.elementRef.nativeElement;
    this.offsetTop = this.element.offsetTop;
    this.elementHeight =   this.element.offsetHeight;
    this.height = window.screen.height;
    this.scrollPosition = ((document.body.scrollTop === 0) ? document.documentElement.scrollTop : document.body.scrollTop);
    this.updateState();
  };

  updateState() {
    if (!this.inZone) {
      if (this.scrollPosition >= (this.offsetTop-this.height*(this.loadPercentage/100))) {
        this.loadAnimation();
        this.inZone = true;
      }
    }
  }

  async loadAnimation() {
    for (let i = 3+this.loadDelay; i >= 0; i -= 0.01*this.speed) {
      this.opacity = 1 - (i / 2);
      await this.delay(1);
    }
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

}
